var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vl-layer-image',{attrs:{"extent":_vm.imageExtent,"opacity":0}},[(_vm.baseSource && _vm.ongoingHistogramExtraction)?_c('vl-source-raster',{attrs:{"sources":[_vm.baseSource],"operation":_vm.pixelObserver,"lib":_vm.operationLib},on:{"beforeoperations":_vm.beforeOperations,"afteroperations":_vm.afterOperations}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }